import { render, staticRenderFns } from "./TotalCom2.vue?vue&type=template&id=2e717e3b&scoped=true"
import script from "./TotalCom2.vue?vue&type=script&lang=js"
export * from "./TotalCom2.vue?vue&type=script&lang=js"
import style0 from "./TotalCom2.vue?vue&type=style&index=0&id=2e717e3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e717e3b",
  null
  
)

export default component.exports